"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _reactRouterDom = require("react-router-dom");
var _FileInput = _interopRequireDefault(require("Components/Forms/Elements/FileInput"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
var _Routing = require("Functions/Routing");
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _fileInputUtilities = require("Components/Forms/Functions/fileInputUtilities");
var _DatePicker = _interopRequireDefault(require("Components/Forms/Elements/DatePicker"));
var _Editor = _interopRequireDefault(require("Components/TextEditor/Editor"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _DefaultModal = _interopRequireDefault(require("Modals/DefaultModal.jsx"));
var _ChatV = _interopRequireDefault(require("../Chat/ChatV2"));
var _ShareProject = _interopRequireDefault(require("./ShareProject"));
var _RenderEditorText = _interopRequireDefault(require("../../../TextEditor/RenderEditorText"));
var _moment = _interopRequireDefault(require("moment"));
var _FileItem = _interopRequireDefault(require("../Files/FileItem"));
var _ProjectStatus = _interopRequireDefault(require("./ProjectStatus"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProjectForm = props => {
  let navigate = (0, _reactRouterDom.useNavigate)();
  const [status_messages, setStatusMessages] = (0, _react.useState)({});
  const [status, setStatus] = (0, _react.useState)({});
  const [loading, setLoading] = (0, _react.useState)(false);
  const [deleting, setDeleting] = (0, _react.useState)(false);
  const [requestType, setRequestType] = (0, _react.useState)("");
  const [requestTitle, setRequestTitle] = (0, _react.useState)("");
  const [lastname, setLastname] = (0, _react.useState)("");
  const [firstname, setFirstname] = (0, _react.useState)("");
  const [gender, setGender] = (0, _react.useState)("");
  const [surgeryDate, setSurgeryDate] = (0, _react.useState)("");
  const [surgeryPlace, setSurgeryPlace] = (0, _react.useState)("");
  const [stlType, setStlType] = (0, _react.useState)("");
  const [birthdate, setBirthdate] = (0, _react.useState)("");
  const [comment, setComment] = (0, _react.useState)();
  const [files, setFiles] = (0, _react.useState)([]);
  const [projectStatus, setProjectStatus] = (0, _react.useState)("open");
  const [deleteModal, setDeleteModal] = (0, _react.useState)();
  const [recordNumber, setRecordNumber] = (0, _react.useState)();
  const requestTypeError = status_messages["project[request_type]"];
  const genderError = status_messages["project[gender]"];
  const stlTypeError = status_messages["project[stl_type]"];
  const userRole = window.app.state.session.user.roles[0];
  const [relatedPratician, setRelatedPratician] = (0, _react.useState)(window.app.state.session.user.login);
  const [showForm, setShowForm] = (0, _react.useState)(false);
  const [sharedWith, setShareWith] = (0, _react.useState)(undefined);
  const [filesList, setFilesList] = (0, _react.useState)([]);
  const [praticianInfos, setPraticianInfos] = (0, _react.useState)();
  const createdBy = window.app.state.session.user.id;
  const praticianLastname = window.app.state.session.user.name;
  const praticianFirstname = window.app.state.session.user.firstname;
  const ref = (0, _react.useRef)(null);
  const loader = loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    className: "c-loader",
    bemit: ['white', 'bg-primary']
  }) : undefined;
  const fetchProject = () => {
    setLoading(true);
    (0, _ajaxRequest.default)((0, _Routing.action)('getAllProjects'), {
      data: {
        id: document.location.pathname.split((0, _Routing.URL)('AdminProjectsDashboard') + "/")[1],
        with_count: false
      }
    }).then(function (response) {
      const {
        request_type,
        request_title,
        patient_lastname,
        patient_firstname,
        gender,
        birthdate,
        stl_type,
        surgery_date,
        surgery_place,
        comment,
        files,
        project_status,
        record_number,
        pratician_login,
        shared_with,
        __user
      } = response.data[0];
      setRequestType(request_type);
      setRequestTitle(request_title);
      setLastname(patient_lastname);
      setFirstname(patient_firstname);
      setGender(gender);
      setBirthdate(birthdate);
      setStlType(stl_type);
      setSurgeryDate(surgery_date);
      setSurgeryPlace(surgery_place);
      setComment(comment);
      setFiles(files || []);
      setProjectStatus(project_status);
      setRecordNumber(record_number);
      setRelatedPratician(pratician_login);
      setLoading(false);
      setShareWith(shared_with);
      setPraticianInfos(__user);
    }).catch(function (errors) {
      console.log(errors);
      setLoading(false);
    });
  };
  const onFormSubmit = async e => {
    setLoading(true);
    let projectFormParams = {
      request_type: requestType,
      request_title: requestTitle,
      patient_lastname: lastname,
      patient_firstname: firstname,
      gender: gender,
      surgery_date: surgeryDate,
      surgery_place: surgeryPlace,
      stl_type: stlType,
      birthdate: birthdate,
      comment: comment,
      files: files,
      created_by: createdBy,
      record_number: recordNumber,
      pratician_firstname: praticianFirstname,
      pratician_lastname: praticianLastname,
      pratician_login: relatedPratician,
      project_status: projectStatus
    };
    try {
      if (props.type === "update") {
        const projectId = document.location.pathname.split((0, _Routing.URL)('AdminProjectsDashboard') + "/")[1];
        let response = await (0, _ajaxRequest.default)((0, _Routing.action)('updateProject'), {
          data: {
            project_form_params: projectFormParams,
            id: projectId
          }
        });
        const {
          statement,
          error,
          info,
          warning
        } = response;
        setStatus({
          statement,
          error,
          info,
          warning
        });
        window.setTimeout(function () {
          window.location.reload();
          /* navigate(URL('AdminProjectsDashboard')); */
        }, 1000);
      } else {
        let response = await (0, _ajaxRequest.default)((0, _Routing.action)('createNewProject'), {
          data: projectFormParams
        });
        const {
          statement,
          error,
          info,
          warning
        } = response;
        setStatus({
          statement,
          error,
          info,
          warning
        });
        window.setTimeout(function () {
          navigate((0, _Routing.URL)('AdminProjectsDashboard'));
        }, 2000);
      }
    } catch (update) {
      const {
        statement,
        error,
        info,
        warning
      } = update;
      setStatus({
        statement,
        error,
        info,
        warning
      });
      setStatusMessages(update.status_messages);
      return setLoading(false);
    }
    setLoading(false);
  };
  const handleFileChange = _ref => {
    let {
      e,
      previews,
      name
    } = _ref;
    setStatusMessages((0, _fileInputUtilities.getStatusMessage)({
      status: status_messages,
      previews,
      name
    }));
    setStatus({});
    setFiles(previews);
  };
  (0, _react.useEffect)(() => {
    if (props.type === "update") {
      fetchProject();
    }
  }, []);
  (0, _react.useEffect)(() => {
    const projectId = document.location.pathname.split((0, _Routing.URL)('AdminProjectsDashboard') + "/")[1];
    (0, _ajaxRequest.default)((0, _Routing.action)('updateProjectStatus'), {
      data: {
        id: projectId,
        project_status: projectStatus
      }
    });
  }, [projectStatus]);
  const deleteProject = async () => {
    var _ref$current, _ref$current$click;
    const projectId = document.location.pathname.split((0, _Routing.URL)('AdminProjectsDashboard') + "/")[1];
    setDeleting(true);
    let response = await (0, _ajaxRequest.default)((0, _Routing.action)('/project/delete'), {
      data: {
        id: projectId
      }
    });
    setStatus(response);
    window.setTimeout(function () {
      navigate((0, _Routing.URL)('AdminProjectsDashboard'));
    }, 2000);
    setLoading(false);
    setDeleting(false);
    (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$click = _ref$current.click) === null || _ref$current$click === void 0 ? void 0 : _ref$current$click.call(_ref$current);
  };
  const footer_del_btn = /*#__PURE__*/_react.default.createElement("button", {
    role: "button",
    "aria-label": "Fermer",
    className: 'c-flat-btn c-flat-btn--red u-margin-right-30',
    onClick: deleteProject
  }, "Supprimer d\xE9finitivement", deleting === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    className: "c-loader",
    bemit: ['white', 'bg-red']
  }) : undefined);
  const handleFilesList = files => {
    if (userRole === 'ortho') {
      const files_sent_by_deltex = files.filter(function (file) {
        return file.files.length !== 0 || file.files === undefined && file.sent_by === 'deltex';
      });
      const files_for_ortho = files_sent_by_deltex.filter(file => ['image', 'pdf'].includes(file.files[0].type));
      setFilesList(files_for_ortho);
    } else {
      const displayed_files = files.filter(file => file.files.length !== 0 || file.files === undefined);
      setFilesList(displayed_files);
    }
  };
  const handleCharedWith = ortho => {
    setShareWith(ortho);
  };
  let projectStatusFR = undefined;
  let statusClass = undefined;
  switch (projectStatus) {
    case 'open':
      (projectStatusFR = "Ouvert") && (statusClass = 'project_infos__status-open');
      break;
    case 'running':
      (projectStatusFR = "En cours") && (statusClass = 'project_infos__status-running');
      break;
    case 'pending':
      (projectStatusFR = "En attente") && (statusClass = 'project_infos__status-pending');
      break;
    case 'over':
      (projectStatusFR = "Terminé") && (statusClass = 'project_infos__status-over');
      break;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.type === 'update' && showForm === false ? /*#__PURE__*/_react.default.createElement("div", {
    className: "project_infos"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "project_infos__left c-paper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "project_infos__head"
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Num\xE9ro de dossier : ", /*#__PURE__*/_react.default.createElement("span", null, recordNumber))), /*#__PURE__*/_react.default.createElement("div", {
    className: "project_infos__body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "project_infos__status"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Status : ", /*#__PURE__*/_react.default.createElement("span", {
    className: statusClass
  }, projectStatusFR))), /*#__PURE__*/_react.default.createElement("h5", null, "Titre : ", /*#__PURE__*/_react.default.createElement("span", null, requestTitle)), /*#__PURE__*/_react.default.createElement("h5", null, "Type de demande : ", /*#__PURE__*/_react.default.createElement("span", null, requestType)), /*#__PURE__*/_react.default.createElement("h5", null, "Goutti\xE8re : ", /*#__PURE__*/_react.default.createElement("span", null, stlType)), /*#__PURE__*/_react.default.createElement("h5", null, "Date che chirurgie : ", /*#__PURE__*/_react.default.createElement("span", null, surgeryDate)), /*#__PURE__*/_react.default.createElement("h5", null, "Lieu d'intervention : ", /*#__PURE__*/_react.default.createElement("span", null, surgeryPlace)), /*#__PURE__*/_react.default.createElement("h5", null, "Commentaire :", /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_RenderEditorText.default, {
    str: comment
  }))), /*#__PURE__*/_react.default.createElement("h5", null, "Fichier de demande initiale :", files && files.map(file => /*#__PURE__*/_react.default.createElement("span", {
    key: file.filename
  }, file.filename, " - ", file.title))))), userRole !== "deltex" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "project_infos__right c-paper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "project_infos__head"
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Informations patient")), /*#__PURE__*/_react.default.createElement("div", {
    className: "project_infos__body"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Nom : ", /*#__PURE__*/_react.default.createElement("span", null, lastname)), /*#__PURE__*/_react.default.createElement("h5", null, "Pr\xE9nom : ", /*#__PURE__*/_react.default.createElement("span", null, firstname)), /*#__PURE__*/_react.default.createElement("h5", null, "Genre : ", /*#__PURE__*/_react.default.createElement("span", null, gender)), /*#__PURE__*/_react.default.createElement("h5", null, "Date de Naissance : ", /*#__PURE__*/_react.default.createElement("span", null, birthdate)))), userRole === "ortho" ? /*#__PURE__*/_react.default.createElement("div", null) : /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: () => setShowForm(true),
    className: "project_infos__modif-button c-paper"
  }, "Modifier la demande")) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "project_infos__right c-paper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "project_infos__head"
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Informations praticien")), /*#__PURE__*/_react.default.createElement("div", {
    className: "project_infos__body"
  }, /*#__PURE__*/_react.default.createElement("h5", null, "Nom : ", /*#__PURE__*/_react.default.createElement("span", null, praticianInfos === null || praticianInfos === void 0 ? void 0 : praticianInfos.firstname, "  ", praticianInfos === null || praticianInfos === void 0 ? void 0 : praticianInfos.name)), /*#__PURE__*/_react.default.createElement("h5", null, "Email : ", /*#__PURE__*/_react.default.createElement("span", null, praticianInfos === null || praticianInfos === void 0 ? void 0 : praticianInfos.login)), /*#__PURE__*/_react.default.createElement("h5", null, "Telephone : ", /*#__PURE__*/_react.default.createElement("span", null, praticianInfos === null || praticianInfos === void 0 ? void 0 : praticianInfos.phone)), /*#__PURE__*/_react.default.createElement("h5", null, "RPPS : ", /*#__PURE__*/_react.default.createElement("span", null, praticianInfos === null || praticianInfos === void 0 ? void 0 : praticianInfos.rpps)))), /*#__PURE__*/_react.default.createElement(_ProjectStatus.default, {
    projectStatus: projectStatus,
    setProjectStatus: setProjectStatus
  }))) : /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: e => onFormSubmit(e),
    className: props.paper !== false ? 'c-paper' : undefined
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 4,
    className: "u-margin-top-10"
  }, props.type === "update" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    className: "u-flex u-items-center u-flex-gap-15"
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Num\xE9ro de dossier : ", recordNumber))) : undefined, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    value: requestTitle,
    onChange: e => setRequestTitle(e.value),
    name: "project[request_title]",
    type: "text",
    label: "Titre de la demande",
    status: status_messages
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 6,
    className: requestTypeError ? 'radio-group radio-group__error' : "radio-group"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "radio-group__name"
  }, "Objet de la demande : "), /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-group__radio"
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    checked: requestType === "Demande de stl",
    onChange: () => setRequestType("Demande de stl"),
    value: "stlRequest",
    color: "primary",
    name: "project[request_type]",
    className: "",
    id: "stl"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "radio-group__label",
    htmlFor: "stl"
  }, "Demande de STL")), /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-group__radio"
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    checked: requestType === "Planification",
    onChange: () => setRequestType("Planification"),
    value: "planning",
    color: "primary",
    name: "project[request_type]",
    className: "",
    id: "planning"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "radio-group__label",
    htmlFor: "planning"
  }, "Planification")), /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-group__radio"
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    checked: requestType === "Planification assistée",
    onChange: () => setRequestType("Planification assistée"),
    value: "assistedPlanning",
    color: "primary",
    name: "project[request_type]",
    className: "",
    id: "assistedPlanning"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "radio-group__label",
    htmlFor: "assistedPlanning"
  }, "Planification assist\xE9e"))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    className: stlTypeError ? 'radio-group radio-group__error' : "radio-group"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "radio-group__name"
  }, "Goutti\xE8re : "), /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-group__radio"
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    checked: stlType === "intermediaire",
    onClick: () => setStlType("intermediaire"),
    value: "intermediaire",
    color: "primary",
    name: "project[stl_type]",
    className: "",
    id: "intermediaire"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "radio-group__label",
    htmlFor: "intermediaire"
  }, "Interm\xE9diaire")), /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-group__radio"
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    checked: stlType === "finale",
    onClick: () => setStlType("finale"),
    value: "finale",
    color: "primary",
    name: "project[stl_type]",
    className: "",
    id: "finale"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "radio-group__label",
    htmlFor: "finale"
  }, "Finale")), /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-group__radio"
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    checked: stlType === "les-deux",
    onClick: () => setStlType("les-deux"),
    value: "les-deux",
    color: "primary",
    name: "project[stl_type]",
    className: "",
    id: "les-deux"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "radio-group__label",
    htmlFor: "les-deux"
  }, "Les deux"))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    className: "u-flex u-items-center u-flex-gap-15"
  }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
    value: surgeryDate,
    onChange: e => setSurgeryDate(e.value),
    label: "Date de chirurgie",
    name: "project[surgery_date]",
    status: status_messages
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    value: surgeryPlace,
    onChange: e => setSurgeryPlace(e.value),
    name: "project[surgery_place]",
    type: "text",
    label: "Lieu de l'intervention",
    status: status_messages
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_Editor.default, {
    "text-only": true,
    label: "Commentaire",
    value: comment,
    onChange: e => setComment(e.value)
  })), props.type === "update" ? undefined : /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
    onChange: handleFileChange,
    value: files,
    name: "project[files]",
    model: "project",
    field: "files",
    label: "Fichier(s)",
    status: status_messages,
    multiple: true,
    accept: "dicom, image, zip"
  }))), userRole === "pratician" ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 4,
    className: "u-margin-top-10"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 12,
    className: "u-flex u-items-center u-flex-gap-15"
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Informations patient")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setLastname(e.value),
    value: lastname,
    name: "project[patient_lastname]",
    type: "text",
    label: "Nom du patient",
    status: status_messages
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setFirstname(e.value),
    value: firstname,
    name: "project[patient_firstname]",
    type: "text",
    label: "Pr\xE9nom du patient",
    status: status_messages
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    className: genderError ? 'radio-group radio-group__error' : "radio-group"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "radio-group__name"
  }, "Genre : "), /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-group__radio"
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    checked: gender == "masculin",
    onClick: () => setGender("masculin"),
    value: "masculin",
    color: "primary",
    name: "project[gender]",
    className: "",
    id: "masculin"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "radio-group__label",
    htmlFor: "masculin"
  }, "Masculin")), /*#__PURE__*/_react.default.createElement("div", {
    className: "radio-group__radio"
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    checked: gender == "feminin",
    onClick: () => setGender("feminin"),
    value: "feminin",
    color: "primary",
    name: "project[gender]",
    className: "",
    id: "feminin",
    status: status_messages
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "radio-group__label",
    htmlFor: "feminin"
  }, "F\xE9minin"))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 6,
    className: "u-flex u-items-center u-flex-gap-15"
  }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
    value: birthdate,
    onChange: e => setBirthdate(e.value),
    label: "Date de naissance",
    name: "project[birthdate]",
    status: status_messages
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)), (0, _getFormStatus.default)(status), props.type === 'update' && showForm === false ? undefined : /*#__PURE__*/_react.default.createElement("div", {
    className: "u-full-width u-flex u-content-between u-text-center u-margin-top-25 u-padding-bottom-20 "
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _bemit.default)('c-flat-btn', ['primary']),
    onClick: onFormSubmit,
    disabled: loading ? true : false
  }, props.type === 'update' ? 'Mettre à jour' : 'Créer le dossier', loader), props.type === 'update' && userRole === 'deltex' ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "c-form__delete",
    onClick: e => setDeleteModal({
      open: true,
      src: e === null || e === void 0 ? void 0 : e.target
    })
  }, "Supprimer dossier", loader) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), /*#__PURE__*/_react.default.createElement(_DefaultModal.default, {
    open: deleteModal === null || deleteModal === void 0 ? void 0 : deleteModal.open,
    onClose: () => setDeleteModal({}),
    bemit: ["small"],
    "close-label": "Annuler",
    "action-buttons": footer_del_btn,
    trigger_src: deleteModal === null || deleteModal === void 0 ? void 0 : deleteModal.src,
    "close-ref": ref
  }, "La suppression du dossier est d\xE9finitive et irr\xE9m\xE9diable. Etes vous sur de vouloir continuer ?")), userRole === 'pratician' && props.type === "update" ? /*#__PURE__*/_react.default.createElement(_ShareProject.default, {
    recordNumber: recordNumber,
    sharedWith: sharedWith,
    handleCharedWith: ortho => handleCharedWith(ortho)
  }) : undefined, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-paper project_chat"
  }, recordNumber && relatedPratician && /*#__PURE__*/_react.default.createElement(_ChatV.default, {
    recordNumber: recordNumber,
    relatedPratician: relatedPratician,
    projectStatus: projectStatus,
    projectId: document.location.pathname.split((0, _Routing.URL)('AdminProjectsDashboard') + "/")[1],
    handleFilesList: files => handleFilesList(files)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "project_chat__files"
  }, userRole === "ortho" ? undefined : /*#__PURE__*/_react.default.createElement(_FileInput.default, {
    onChange: handleFileChange,
    value: files,
    name: "project[files]",
    model: "project",
    field: "files",
    label: "Fichier demande initiale",
    status: status_messages,
    multiple: true,
    accept: "dicom, image, zip",
    "read-only": true
  }), /*#__PURE__*/_react.default.createElement("h3", null, "Fichier(s) \xE9chang\xE9(s)"), filesList && filesList.map(file => /*#__PURE__*/_react.default.createElement(_FileItem.default, {
    key: file.message_date,
    file: file,
    messageDate: file.message_date,
    handleFilesList: files => handleFilesList(files)
  })))));
};
var _default = exports.default = ProjectForm;
